import { anchorScroll } from "./modules/anchorScroll";
import { lineup } from "./modules/lineup";
import { lineupSlider } from "./modules/lineupSlider";
import { lineupCursor } from "./modules/lineupCursor";
import { header } from "./modules/header";
import { lineupModals } from "./modules/lineupModals";
import { lineupModalSliders } from "./modules/lineupModalSliders";
import { lottie } from "./modules/lottie";
import { menu } from "./modules/menu";
import { inview } from "./modules/inview";
import { inviewFull } from "./modules/inviewFull";
import { mvSlider } from "./modules/mvFadeSlider";
import { aboutIntro } from "./modules/aboutIntro";
import { igSlider } from "./modules/igSlider";
import { stickyLineupBtn } from "./modules/stickyLineupBtn";
import { lineupToc } from "./modules/lineupToc";
import { shopSlider } from "./modules/shopSlider";
import { shopModals } from "./modules/shopModals";
import { shopModalSliders } from "./modules/shopModalSliders";
import { lineupPriceToggle } from "./modules/lineupPriceToggle";
import { simpleBarOnTables } from "./modules/simpleBarOnTables";

window.addEventListener("DOMContentLoaded", function () {
  anchorScroll();
  header();
  menu();
  inview(".inview", {
    rootMargin: "-15% 0px",
  });
  inview(".inview-custom", {
    rootMargin: "-15% 0px",
  });
  inview(".inview-overlay", {
    rootMargin: "-60% 0px",
  });
  inviewFull(".inview-full", {
    threshold: 0.9,
  });
  mvSlider();
  stickyLineupBtn();
  aboutIntro();
  lineup();
  lineupSlider();
  lineupCursor();
  lineupModals();
  lineupModalSliders();
  igSlider();
  lottie();
  lineupToc();
  shopSlider();
  shopModals();
  shopModalSliders();
  lineupPriceToggle();
  simpleBarOnTables();
});
